"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Channels Service
 * Channels Service REST API for Frumos.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamingRestrictionType = void 0;
/**
 * Restrictions that can be assigned to a streaming session.
 * @export
 * @enum {string}
 */
exports.StreamingRestrictionType = {
    Allowed: 'allowed',
    Blocked: 'blocked',
    CheckWithMso: 'checkWithMso'
};
